import React, { useEffect, useRef, useState } from 'react'
import NavbarContainer from '../components/NavbarContainer/NavbarContainer'
import AuthButtos from '../components/AuthButtos/AuthButtos'
import HeroSection from '../components/HeroSection/HeroSection'
import About from '../components/About/About'
import FeaturesSection from '../components/FeaturesSection/FeaturesSection'
import axios from 'axios'
import { getStgees } from '../hooks/stages'
import { useDispatch, useSelector } from 'react-redux'
import { getExpenses } from '../hooks/expenses'
import Footer from '../components/Footer/Footer'
import { useLocation } from 'react-router-dom'

function Home() {
    const [loading, setLoading] = useState(false);
        const userinfo = useSelector((state) => state.auth);

  const homeRef = useRef(null)
    const location = useLocation();

  const aboutRef = useRef(null)
  const featuresRef = useRef(null)

  // 👇 Smooth scroll function
  const scrollToSection = (section) => {
    const refs = {
      home: homeRef,
      about: aboutRef,
      Features: featuresRef,
    }

    const ref = refs[section]
    if (ref?.current) {
      ref.current.scrollIntoView({ behavior: 'smooth', block: 'start' })
    }
  }

  const dispatch = useDispatch()
  useEffect(() => {
    const getData = async () => {

      try {
        const response = await axios.get(`https://nanosoft.space/taarteb/public/api/students/schools/3/grade-categories`);

        const optionsRes = response.data.data.map(item => ({
          value: item.id,
          label: item.name
        }));
        dispatch(getStgees(optionsRes))



      } catch (error) {
        setLoading(false)

      } finally {
        setLoading(false);
      }
      try {
        const response = await axios.get(`https://nanosoft.space/taarteb/public/api/expenses?school_id=3`);
        dispatch(getExpenses(response.data.data))
        // const fiterData=response.data.data.filter((item)=>item?.id==activeFee)
        // setActiveFeeData(fiterData)

        // if (response.data.data.length > 0 && !activeFee) {
        //   setActiveFee(response.data.data[0].id);
        //   setActiveFeeData([response.data.data[0]]);
        // } else {
        //   const filterData = response.data.data.filter((item) => item?.id === activeFee);
        //   setActiveFeeData(filterData);
        // }
      } catch (error) {

      } finally {
      }


    }
    getData()
  }, [])
  useEffect(() => {
    if (location.hash) {
      const element = document.querySelector(location.hash);
      if (element) {
        element.scrollIntoView({ behavior: "smooth" });
      }
    }
  }, [location]);

  return (
    <div>
      <NavbarContainer scrollToSection={scrollToSection} />
      <div ref={homeRef}id={'home'}>

        <HeroSection />
        {
Object.keys(userinfo.userArray).length==0&&
        <AuthButtos />

}

      </div>
      <div ref={aboutRef}id={"about"}>

        <About />
      </div>
      <div ref={featuresRef}id={"features"}>

        <FeaturesSection />
      </div>
      <Footer scrollToSection={scrollToSection} />
      {/* <EventsSection />
      <ActivitiesSection />
      <NewsSection /> */}
      {/* <Footer /> */}

    </div>
  )
}

export default Home